import { LexIcon } from "../../../../../assets/icons/lex";
import { PDLTypography } from "../../dna";
import AnalyzeLoading from "../_analyseLoading";

interface LexLoadingProps {
  dur?: number;
  customText?: string;
  size?: number;
}

const LexLoading = ({ dur = 2, customText, size = 180 }: LexLoadingProps) => {
  const width = size;
  const height = (size * 80) / 180;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "relative",
          width,
          height,
        }}
      >
        <div
          style={{
            position: "relative",
            width,
            height: height * 2.5,
          }}
        >
          <LexIcon
            color="#E3E8E3"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width,
              height,
            }}
          />

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 180 80"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
            }}
          >
            <defs>
              <clipPath id="lex-reveal">
                <rect id="lex-mask" x="0" y="0" width="0" height="80" />
              </clipPath>
            </defs>

            <LexIcon clipPath="url(#lex-reveal)" />

            <animate
              xlinkHref="#lex-mask"
              attributeName="width"
              from="0"
              to="180"
              dur={`${dur}s`}
              repeatCount="indefinite"
            />
          </svg>
        </div>

        <div
          style={{
            position: "absolute",
            right: -(size * 0.18),
            bottom: -(size * 0.16),
            pointerEvents: "none",
          }}
        >
          <AnalyzeLoading size={size * 0.65} />
        </div>
      </div>

      {customText && (
        <PDLTypography size="md" weight="medium">
          {customText}
        </PDLTypography>
      )}
    </div>
  );
};

export default LexLoading;
